module.exports = __webpack_public_path__ + "static/media/wrong-effect.9f017a70.mp3";